import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { Dialog, IconButton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import moment from "moment";
import "./CallScheduleDialog.css";
import { getListCallSchedule } from "../Store/Actions/OutboundAction";
import { SET_CALL_SCHEDULE_ASSIGNMENT_ID } from "../Store/Types/AgentTypes";

const CallScheduleDialog = ({
  changePage,
  isOpen,
  setIsOpen,
  setIsSettingsShown,
}) => {
  const [listCallSchedule, setListCallSchedule] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const { myInfo } = useSelector((state) => state.auth);

  useEffect(() => {
    setIsLoading(true);

    getListCallSchedule(myInfo.user.AgentID)
      .then((response) => {
        if (response.status) {
          console.log("List call schedule: ", response.data);
          setListCallSchedule(response.data);
        } else {
          console.log("error", response.error);
        }

        setIsLoading(false);
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });
  }, [isOpen]);

  const columns = [
    {
      field: "ScheduleTime",
      flex: 1,
      headerName: "Schedule Time",

      renderCell: (params) =>
        moment.utc(params.row.ScheduleTime).format("DD-MMM-yyyy HH:mm:ss"),
    },

    {
      field: "ContactName",
      flex: 1,
      headerName: "Contact Name",
    },

    {
      field: "LastActionTime",
      flex: 1,
      headerName: "Last Action",

      renderCell: (params) =>
        moment.utc(params.row.LastActionTime).format("DD-MMM-yyyy HH:mm:ss"),
    },

    {
      field: "StatusName",
      flex: 1,
      headerName: "Status",
    },

    {
      field: "CampaignName",
      flex: 1,
      headerName: "Campaign",
    },

    {
      align: "center",
      flex: 1,
      headerAlign: "center",
      headerName: "Action",
      maxWidth: 100,

      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              dispatch({
                type: SET_CALL_SCHEDULE_ASSIGNMENT_ID,
                payload: params.row.AssignmentID,
              });

              setIsOpen(false);
              setIsSettingsShown(false);
              changePage("campaign");
            }}
          >
            <Icon
              color="#7e7e7e"
              height="26"
              icon="ic:baseline-remove-red-eye"
              width="26"
            />
          </IconButton>
        );
      },
    },
  ];

  return (
    <Dialog
      open={isOpen}
      className="dialog call-schedule"
      fullWidth
      maxWidth="xl"
      scroll="paper"
      onClose={() => setIsOpen(false)}
    >
      <div className="dialog-container">
        <div className="dialog-content">
          <IconButton className="close-button" onClick={() => setIsOpen(false)}>
            <CloseOutlined />
          </IconButton>

          <div className="title">
            <h2>Call Schedule</h2>
          </div>

          <div className="container">
            <div className="call-schedule-content">
              <DataGrid
                className="table"
                columns={columns}
                disableColumnFilter
                disableColumnMenu
                disableSelectionOnClick
                hideFooter
                loading={isLoading}
                rows={listCallSchedule}
                getRowId={(row) => row.CallScheduleID}
              />
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default CallScheduleDialog;
